import { render, staticRenderFns } from "./MainTemplate.vue?vue&type=template&id=20f01bff&scoped=true"
import script from "./MainTemplate.vue?vue&type=script&lang=js"
export * from "./MainTemplate.vue?vue&type=script&lang=js"
import style0 from "./MainTemplate.vue?vue&type=style&index=0&id=20f01bff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f01bff",
  null
  
)

export default component.exports